import React from 'react';

import CommonReportMobile from './mobile/ReportMobile';
import { isPc } from '@/utils/utils';
import CommonReportPc from './commonReportPc';

export default () => {
  return <CommonReportPc />;
  // if (isPc) {
  //   return <CommonReportPc />;
  // } else {
  //   return <CommonReportMobile />;
  // }
};



